import { MifeParcel } from '@/components/MifeParcel';
import { createFileRoute } from '@tanstack/react-router';

// TT-133: mounts the version-one parcel for the Wakala details list (/wakala).
// The Vue router handles the page; this host route just makes the path resolve.
export const Route = createFileRoute('/_authenticated/_pfida/wakala')({
  component: () => <MifeParcel />,
});
